import { Box, type SxProps, type Theme } from "@mui/material";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { ClusterMenuItem, ClusterSelect } from "./LeaderboardClusterSelect.styles";
import { useLeaderboardClusterStore, useCurrentLeaderboardCluster } from "../../stores";


export function LeaderboardClusterSelect({ sx }:{ sx?: SxProps<Theme> }) {
  const [open, setOpen] = useState(false);
  const { isLoading, availableClusters: clusters, currentCluster } = useCurrentLeaderboardCluster();
  const { setCurrentCluster } = useLeaderboardClusterStore();
  if(!isLoading && clusters.length>1) {
    return <>
      <ClusterSelect color="info" value={ currentCluster?.id } open={ open } onOpen={ () => setOpen(true) } onClose={ () => setOpen(false) } onChange={ (evt) => {
        const selectedCluster = clusters.find((cluster) => cluster.id === evt.target.value);
        setCurrentCluster(selectedCluster);
      } } IconComponent={ () => <ChevronDown  size={ 20 } style={ {
        transition: "all .3s linear",
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
        cursor: "pointer"
      } } onClick={ () => setOpen((cur) => !cur) } /> } renderValue={ (value) => {
        const selectedCluster = clusters.find((cluster) => cluster.id === value);
        return <Box
          display="flex"
          alignItems="center"
          minWidth={ 0 }
        >
          <Box
            sx={ {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              minWidth: 0
            } }
          >
            { selectedCluster?.name }
          </Box>
        </Box>;
      } } MenuProps={ {
        PaperProps: {
          sx: (theme) => ({
            marginTop: theme.spacing(1),
            padding: theme.spacing(3)
            //background: `${theme.linearGradients.gradientB}!important`
          })
        }
      } } sx={ sx }>
        {
          clusters.map((cluster) => <ClusterMenuItem value={ cluster.id } key={ cluster.id }>{ cluster.name }</ClusterMenuItem>)
        }
      </ClusterSelect>
    </>;
  }
  return <></>;
}



